import React, { useMemo } from "react";

import type { DefaultTheme } from "styled-components";
import styled, { useTheme } from "styled-components";

import AnimatedDot from "./AnimatedDot";
import { usePolyAnimationSync } from "./hooks/usePolyAnimationSync";
import { delays, pathData } from "./pathData";
import { getPolyLoaderConfig } from "./PolyLoaderConfig";

const Svg = styled.svg`
  display: block;
`;

export interface PolyLoaderProps {
  type?: "greyscale" | "logo";
}

const PolyLoaderComponent: React.FC<PolyLoaderProps> = ({
  type: type = "greyscale",
}) => {
  const theme = useTheme() as DefaultTheme;
  const { sync: globalSync } = usePolyAnimationSync();
  const themeConfig = useMemo(() => getPolyLoaderConfig(theme), [theme]);

  return (
    <Svg viewBox="0 0 32 32">
      {pathData.map((d, i) => {
        const colorConfig = themeConfig[type];
        return (
          <AnimatedDot
            key={d}
            d={d}
            delay={globalSync + delays[i]}
            fill={colorConfig.fill}
            fillActive={colorConfig.fillActive}
            stroke={colorConfig.stroke}
            strokeActive={colorConfig.strokeActive}
          />
        );
      })}
    </Svg>
  );
};

export const PolyLoader = React.memo(PolyLoaderComponent);
PolyLoader.displayName = "PolyLoader";
export default PolyLoader;
